import React from 'react'
import PropTypes from 'prop-types'
import BlockContent from '../shared/blockContent'

import Logotype from '../../images/AM_Logotype.svg'
import './footer.css'

const Footer = ({ siteConfig }) => {
  const year = new Date().getFullYear()

  return (
    <footer>
      <div className="content">
        <div className="name">
          <img src={Logotype} alt="Active Matter" />
          <a href={'mailto:' + siteConfig.email}>{siteConfig.email}</a>
        </div>
        <div className="address">
          {typeof siteConfig.offices[0].address === 'string' ? (
            <address>{siteConfig.offices[0].address}</address>
          ) : (
            <BlockContent input={siteConfig.offices[0].address}></BlockContent>
          )}
        </div>
        <div className="social">
          <h3>Follow us</h3>
          {siteConfig.social.map((service, index) => (
            <a href={service.url} key={`social-${index}`}>
              {service.name}
            </a>
          ))}
        </div>
      </div>
      <div className="copy">
        <p>© {year} Active Matter</p>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  siteConfig: PropTypes.object,
}

export default Footer
